{
  "INAPP-2055.spotlight.body": [
    {
      "type": 0,
      "value": "Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"
    }
  ],
  "INAPP-2055.spotlight.primary": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "INAPP-2055.spotlight.secondary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-2055.spotlight.title": [
    {
      "type": 0,
      "value": "Create rich and informative alerts"
    }
  ],
  "INAPP-2092.spotlight.body": [
    {
      "type": 0,
      "value": "Enhance your team's operations by grouping similar alerts using Atlassian Intelligence. This helps your team keep alert fatigue at bay and resolve issues faster."
    }
  ],
  "INAPP-2092.spotlight.primary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-2092.spotlight.secondary": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "INAPP-2092.spotlight.title": [
    {
      "type": 0,
      "value": "Alerts grouped by Atlassian Intelligence"
    }
  ],
  "INAPP-2095.spotlight.body": [
    {
      "type": 0,
      "value": "Create PIRs faster and more intelligently to facilitate quicker resolutions and more effective prevention of future incidents."
    }
  ],
  "INAPP-2095.spotlight.primary": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "INAPP-2095.spotlight.secondary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-2095.spotlight.title": [
    {
      "type": 0,
      "value": "Supercharge your PIR with Atlassian Intelligence "
    }
  ],
  "INAPP-3273.spotlight.body": [
    {
      "type": 0,
      "value": "Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts."
    }
  ],
  "INAPP-3273.spotlight.primary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-3273.spotlight.title": [
    {
      "type": 0,
      "value": "Drive faster alert resolution with Atlassian Intelligence"
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.body": [
    {
      "type": 0,
      "value": "Expand to quickly view all alerts in the group."
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.title": [
    {
      "type": 0,
      "value": "View grouped alerts"
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.body": [
    {
      "type": 0,
      "value": "Rovo helps you classify your alerts as signal or noise so you can focus on what matters most."
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.title": [
    {
      "type": 0,
      "value": "Triage alerts faster"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.go-back": [
    {
      "type": 0,
      "value": "Go back"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ]
}